import {
  AfterContentInit,
  Component,
  ContentChild,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ButtonComponent, ButtonVariant } from '@zelis/dls/button';
import { MatExpansionPanel } from '@angular/material/expansion';
import { merge, Observable, of, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AvatarComponent } from '@zelis/dls/avatar';

@Directive({
  selector: '[zelisExpansionPanelRightIcon]',
})
export class ExpansionPanelRightIconDirective {
  constructor(private elementRef: ElementRef) {
    this.elementRef.nativeElement.style.width = '100%';
    this.elementRef.nativeElement.style.height = '100%';
  }
}

@Component({
  selector: 'zelis-expansion-panel-header-content',
  templateUrl: './expansion-panel-header-content.component.html',
  styleUrls: ['./expansion-panel-header-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExpansionPanelHeaderComponent
  implements OnInit, AfterContentInit, OnDestroy
{
  @HostBinding() class = 'zelis-dls';
  /**
   * String to use as title content
   */
  @Input() title!: string;
  /**
   * String to use as description content
   */
  @Input() description?: string;
  /**
   * Variant of the button to be rendered when the panel is expanded
   */
  @Input() expandedButtonVariant?: ButtonVariant;

  @ContentChild(AvatarComponent) avatar?: AvatarComponent;
  @ContentChild(ButtonComponent) button?: ButtonComponent;

  @ContentChild(ExpansionPanelRightIconDirective)
  rightIcon?: ExpansionPanelRightIconDirective;
  panelOpenState = false;
  currentButtonVariant$!: Observable<ButtonVariant>;
  isExpanded$!: Observable<boolean>;

  /**
   * denotes the button variant that's originally defined
   * on the button, before we change it based on the
   * expanded state
   */
  private defaultButtonVariant!: ButtonVariant;
  private destroy = new Subject<boolean>();

  constructor(public expansionPanel: MatExpansionPanel) {}

  ngOnInit() {
    this.isExpanded$ = merge(
      of(this.expansionPanel.expanded),
      this.expansionPanel.expandedChange
    );

    this.currentButtonVariant$ = this.isExpanded$.pipe(
      map((isExpanded) =>
        isExpanded && this.expandedButtonVariant
          ? this.expandedButtonVariant
          : this.defaultButtonVariant
      )
    );
  }

  ngAfterContentInit() {
    this.configureButton();
  }

  ngOnDestroy() {
    this.destroy.next(true);
  }

  private configureButton() {
    if (!this.button) return;

    const button = this.button;
    this.defaultButtonVariant = button.variant;
    button.size = 'medium';

    this.currentButtonVariant$
      .pipe(takeUntil(this.destroy))
      .subscribe((buttonVariant) => {
        this.defaultButtonVariant = button.variant;
        button.variant = buttonVariant;
      });
  }
}
